package com.example.readingnotes.data.remote.mapper

import com.example.readingnotes.data.remote.dto.NotificationDto
import com.example.readingnotes.data.remote.dto.NotificationSettingsDto
import com.example.readingnotes.data.remote.dto.NotificationsResponseDto
import com.example.readingnotes.domain.model.Notification
import com.example.readingnotes.domain.model.NotificationSettings
import com.example.readingnotes.domain.model.PaginatedNotifications
import com.example.readingnotes.domain.model.toNotificationType
import kotlinx.datetime.Instant

fun NotificationDto.toDomain(): Notification =
    Notification(
        id = id,
        type = type.toNotificationType(),
        title = title,
        body = body,
        data = data,
        isRead = isRead,
        relatedPostId = relatedPostId,
        relatedCommentId = relatedCommentId,
        createdAt = Instant.parse(createdAt),
        readAt = readAt?.let { Instant.parse(it) },
    )

fun List<NotificationDto>.toDomain(): List<Notification> = map { it.toDomain() }

fun NotificationSettingsDto.toDomain(): NotificationSettings =
    NotificationSettings(
        enableNewPost = enableNewPost,
        enableNewComment = enableNewComment,
        enableCommentReply = enableCommentReply,
        enableMention = enableMention,
        enableSystem = enableSystem,
        muteStart = muteStart,
        muteEnd = muteEnd,
    )

fun NotificationSettings.toDto() =
    com.example.readingnotes.data.remote.dto.NotificationSettingsDto(
        enableNewPost = enableNewPost,
        enableNewComment = enableNewComment,
        enableCommentReply = enableCommentReply,
        enableMention = enableMention,
        enableSystem = enableSystem,
        muteStart = muteStart,
        muteEnd = muteEnd,
    )

fun NotificationsResponseDto.toDomain(): PaginatedNotifications {
    val hasMore = offset + limit < total
    return PaginatedNotifications(
        notifications = notifications.toDomain(),
        total = total,
        limit = limit,
        offset = offset,
        hasMore = hasMore,
    )
}
